<template>
  <div class="export-cv-overlay">
    <div class="export-cv-modal">
      <div class="card__body">
        <div class="card-header">Select format</div>
        <div class="card-body">
          <div class="card-widget">
            <div class="card-info">
              <img for="json" src="@/assets/images/icons/json.svg" alt />
              <label for="json">Json/Data</label>
            </div>
            <input
              class="check-input"
              name="download-type"
              type="radio"
              value="json"
              id="json"
              v-model="download_type"
            />
          </div>
          <div class="card-widget">
            <div class="card-info">
              <img for="word" src="@/assets/images/icons/word.svg" alt />
              <label for="word">Word</label>
            </div>
            <input
              class="check-input"
              name="download-type"
              type="radio"
              value="docx"
              id="word"
              v-model="download_type"
            />
          </div>
        </div>
        <div class="card-options">
          <consultfied-button
            class="btn-save"
            :loading="is_loading"
            @click="exportCV()"
            >Export CV</consultfied-button
          >
          <button class="btn-cancel" @click="onClose()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
export default {
  name: "export-cv",
  components: {
    consultfiedButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    names: {
      type: String,
      default: "file",
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      show: true,
      showExport: false,
      download_type: "docx",
      temp_name: "template1.docx",
      is_loading: false,
      data_id: null,
      data_names: "",
    };
  },
  watch: {
    visible(val) {
      this.showExport = val;
    },
    id(val) {
      this.data_id = val;
    },
    names(val) {
      this.data_names = val;
    },
  },
  mounted() {
    this.showExport = this.visible;
    this.data_id = this.id;
    this.data_names = this.names;
  },
  methods: {
    exportCV() {
      this.is_loading = true;
      if (this.download_type == "docx") {
        this.$store
          .dispatch("EXPORT_CONSULTANT_CV", {
            id: this.data_id,
            type: this.download_type,
            names: this.data_names + " CV",
            template: this.temp_name,
          })
          .then((responce) => {
            this.is_loading = false;
            this.onClose();
          })
          .catch((error) => {
            this.is_loading = false;
          });
      } else {
        this.$store
          .dispatch("EXPORT_CONSULTANT_CV", {
            id: this.data_id,
            type: this.download_type,
            names: this.data_names + " CV",
          })
          .then((responce) => {
            this.loading = false;
            this.onClose();
          })
          .catch((error) => {
            this.loading = false;
          });
      }
    },
    onClose() {
      let vm = this;
      this.$emit("onClose", null);
    },
  },
};
</script>
<style scoped lang="scss">
.export-cv-overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba($color: #000000, $alpha: 0.5);
  width: 100%;
  z-index: 9999;
  display: block;
  padding-top: 50px;
  .export-cv-modal {
    margin: 0 auto;
    width: 500px;
    background: #fff;
    border-radius: 5px;
    .card__body {
      z-index: 9999;
      width: 100%;
      padding: 0px;
      .card-header {
        display: flex;
        align-items: center;
        height: 40px;
        font-size: 16px;
        font-weight: 800;
        padding: 0px 20px;
      }
      .card-body {
        display: flex;
        flex-direction: column;
        padding: 20px 20px;
        .card-widget {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 15px;
          border: 1px solid #ddd;
          margin-bottom: 10px;
          border-radius: 5px;
          .card-info {
            display: flex;
            align-items: center;
            img {
              width: 30px;
              margin-right: 10px;
            }
            label {
            }
          }
          .check-input {
          }
        }
      }
      .card-options {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn-save {
          background: #0884af;
          color: #fff;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 45px;
          width: 100px;
          padding: 6px 15px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 20px;
          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
        .btn-cancel {
          background: transparent;
          color: #1ba5a4;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 40px;
          width: 100px;
          padding: 3px 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 20px;
          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
      }
    }
  }
}
</style>
